import { render, staticRenderFns } from "./TradeFinalizePage.vue?vue&type=template&id=6de97f94"
import script from "./TradeFinalizePage.vue?vue&type=script&lang=js"
export * from "./TradeFinalizePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports